module.exports = __webpack_public_path__ + "img/pmed-logo.b79309cd.jpg";